import script from "./InstallmentTable.vue?vue&type=script&setup=true&lang=js"
export * from "./InstallmentTable.vue?vue&type=script&setup=true&lang=js"

import "./InstallmentTable.vue?vue&type=style&index=0&id=1d7aada6&scopped=true&lang=css"

const __exports__ = script;

export default __exports__